import * as i0 from "@angular/core";
export class PostcodeManagerService {
    constructor() {
        this.SelectedPostcodeGroup = null;
        this.PostcodeGroups = [];
    }
}
PostcodeManagerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PostcodeManagerService_Factory() { return new PostcodeManagerService(); }, token: PostcodeManagerService, providedIn: "root" });
